import { Component, Input, OnInit } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { Router } from "@angular/router";
import { UserService } from "../../../../domain/user-service";
import { Channel } from "../../../../domain/channel";
import { User } from "../../../../domain/user";

@Component({
  selector: "icn-channel-wizard-done",
  templateUrl: "./done.html",
  styleUrls: ["./done.scss"],
})
export class ChannelWizardDoneComponent implements WizardSubstep {
  constructor(
    private router: Router,
    private userService: UserService,
  ) {}

  @Input() channel: Channel;
  @Input() isCreate: boolean;

  @Input()
  currentUser: User;

  takeToScheduler() {
    this.userService.setCurrentChannel(this.channel);
    this.router.navigateByUrl("", { replaceUrl: true });
  }

  canGoNext() {
    return false;
  }
}
